import React from 'react';
import { Stack } from '@mui/material';
import { IFloatingActionsButtons } from './interfaces';

export const FloatingActionsButtons: React.FC<IFloatingActionsButtons> = ({
  children,
}): JSX.Element => {
  return (
    <Stack
      direction="row"
      gap="8px"
      sx={{
        position: 'fixed',
        right: '15px',
        bottom: '15px',
      }}
    >
      {children}
    </Stack>
  );
};
